import { useEffect, useState, RefObject, Dispatch, SetStateAction, useCallback } from 'react';

export const useDetectOutsideClick = (
	el: RefObject<HTMLDivElement | null>,
	initialState?: boolean,
	escapeKeyEnabled: boolean = true,
): [boolean | undefined, Dispatch<SetStateAction<boolean | undefined>>] => {
	const [isActive, setIsActive] = useState(initialState);

	const onClick = useCallback(
		(e: MouseEvent) => {
			//alert('click');
			//alert(JSON.stringify(el));

			//console.log('DROPDOWN-----');
			//console.log('CURRENT: ', el?.current);

			if (el?.current !== null && !el.current.contains(<Node>e.target)) {
				setIsActive(false);
			}

			//console.log(el?.current);
		},
		[el],
	);

	const onKey = (e: KeyboardEvent) => {
		if (e.keyCode === 27) {
			setIsActive(false);
		}
	};

	useEffect(() => {
		//console.log('Dropdown render', isActive);

		if (isActive) {
			window.addEventListener('click', onClick);

			if (escapeKeyEnabled) {
				window.addEventListener('keydown', onKey);
			}
		}

		return () => {
			window.removeEventListener('click', onClick);

			if (escapeKeyEnabled) {
				window.removeEventListener('keydown', onKey);
			}
		};
	}, [isActive, el, escapeKeyEnabled, onClick]);

	return [isActive, setIsActive];
};
